import React from 'react';

/**
 * The approved NYCEM primary logo (seal + wordmark).
 *
 * One component so the brand guide's rules (2026 NYCEM Agency Brand Guide, pp. 4–7)
 * are applied in one place rather than remembered at each call site:
 *   - never narrower than 225px on screen;
 *   - aspect ratio locked (no stretching): width is set, height follows;
 *   - no recolouring, shadow or glow: the white file goes on NYCEM Blue, the black
 *     file on white, and nothing else.
 *
 * Files live in public/brand. They were cut from the logo files supplied by NYCEM;
 * replace them with vector originals if Communications provides them.
 */
export const LOGO_MIN_WIDTH = 225;

interface Props {
  /** 'white' for dark backgrounds (NYCEM Blue), 'black' for light ones. */
  variant: 'white' | 'black';
  /** Rendered width in px. Clamped to the 225px minimum. */
  width?: number;
  style?: React.CSSProperties;
}

const NycemLogo: React.FC<Props> = ({ variant, width = LOGO_MIN_WIDTH, style }) => (
  <img
    src={`/brand/nycem-logo-${variant}.png`}
    alt="NYCEM — New York City Emergency Management"
    width={Math.max(width, LOGO_MIN_WIDTH)}
    style={{
      display: 'block',
      width: Math.max(width, LOGO_MIN_WIDTH),
      minWidth: LOGO_MIN_WIDTH,
      maxWidth: 'none',
      height: 'auto',
      ...style,
    }}
  />
);

export default NycemLogo;
